module.exports = __webpack_public_path__ + "static/img/elegantManners1.569d865c.png";